import React, { useState, useEffect } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import './TilDetail.css';
import Loading from '../../common/Loading';

function TilDetail() {
  const { date } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    
    fetch(`https://api.mutantbutton2.com/public/til/${date}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Post not found');
        }
        return response.json();
      })
      .then(data => {
        setPost(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching TIL post:', error);
        setError(error.message);
        setLoading(false);
      });
  }, [date]);

  if (loading) {
    return <div className="til-detail"><Loading /></div>;
  }

  if (error) {
    return <div className="til-detail error">Error: {error}</div>;
  }

  if (!post) {
    return <div className="til-detail">Post not found</div>;
  }

  const getImageUrl = (imageName) => {
    return `https://raw.githubusercontent.com/mutantbutton2/todayilearnt/main/content/${post.date}/${imageName}`;
  };

  return (
    <div className="til-detail">
      <nav className="breadcrumb">
        <NavLink to="/">Home</NavLink>
        <span className="separator">{'>'}</span>
        <NavLink to="/til">TIL</NavLink>
        <span className="separator">{'>'}</span>
        <span className="current">{post.date}</span>
      </nav>

      <div className="til-post">
        {post.images && post.images.length > 0 && (
          <div className="til-images">
            {post.images.length === 1 ? (
              <div className="til-image-single">
                <img src={getImageUrl(post.images[0])} alt={post.title} />
              </div>
            ) : (
              <div className="til-image-grid">
                {post.images.map((image, index) => (
                  <div key={index} className="til-image-item">
                    <img src={getImageUrl(image)} alt={`${post.title} - ${index + 1}`} />
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <div className="til-post-content">
          <div className="til-post-header">
            <div className="til-post-date">{post.date}</div>
            <h1 className="til-post-title">{post.title}</h1>
          </div>

          {post.description && (
            <p className="til-post-description">{post.description}</p>
          )}

          <div className="til-post-text">
            {post.content.split('\n').map((paragraph, index) => (
              paragraph.trim() && (
                <p key={index}>{paragraph}</p>
              )
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TilDetail;
